import { useRef, useState } from "react";
import "./App.css";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];

const whyChooseUs = [
  {
    title: "Local, Cork-based team",
    body: "We’re on the ground in Cork, so site visits, pricing and mobilisation are quick.",
    points: [
      "Serving Cork city & surrounding areas",
      "Ideal for domestic, commercial & local authority",
      "Easy to reach, easy to deal with",
    ],
  },
  {
    title: "Built for civil standards",
    body: "We work to drawings, levels and spec – not guesswork.",
    points: [
      "Foundations and drainage to engineer’s details",
      "Tidy, accurate external works",
      "We leave it ready for the next trade",
    ],
  },
  {
    title: "Safety-first approach",
    body: "Trained crews, PPE and method of work so your site stays compliant.",
    points: [
      "Fully insured",
      "Safe Pass / CSCS operatives",
      "Site kept tidy and organised",
    ],
  },
  {
    title: "Our Fleet",
    body: "We operate and maintain a full fleet to support civil and groundworks projects",
    points: [
      "25T excavator",
      "2 × 13.5T excavators",
      "8T excavator",
      "3T mini digger",
      "2 × 9T dumpers",
      "2 × 6T dumpers",
      "Tractor with dumper trailer",
      "GPS-equipped for accurate setting out",
    ],
  },
  {
    title: "Our Team",
    body: "A skilled workforce of 12 professionals led by experienced site and engineering staff.",
    points: [
      "Senior Civil Engineer",
      "Safety Officer",
      "Black Hat–qualified Foremen",
      "Quantity Surveyor",
    ],
  },
];

const services = [
  {
    title: "Excavation & Site Preparation",
    description:
      "Bulk digs, foundations, reduced levels and cart-away for new builds, extensions and commercial sites.",
    items: [
      "Topsoil strip & spoil removal",
      "Foundation trenches to drawings",
      "Site clearance & levelling",
    ],
  },
  {
    title: "Drainage & Utility Installations",
    description:
      "Foul and surface water systems installed to spec, with ducting for ESB, water and telecoms.",
    items: [
      "Foul & storm drainage",
      "Manholes & inspection chambers",
      "Ducting for services",
    ],
  },
  {
    title: "Foundations & Concrete Works",
    description:
      "Strip foundations, slabs, footpaths and concrete yards poured and finished properly.",
    items: [
      "Concrete foundations",
      "Concrete paths & ramps",
      "Slabs / bases for sheds & plant",
    ],
  },
  {
    title: "Kerbing, Paving & External Works",
    description:
      "Clean external finishes for domestic and commercial areas around Cork.",
    items: [
      "Road kerbs & edgings",
      "Concrete & paved footpaths",
      "Block paving / driveway prep",
    ],
  },
  {
    title: "Siteworks & Ground Improvement",
    description:
      "Hardcore, compaction, drainage channels and preparation for tarmac or surfacing.",
    items: [
      "Hardcore supply & lay",
      "Compaction & level checks",
      "ACO / surface drainage",
    ],
  },
  // {
  //   title: "Small Civil Construction",
  //   description:
  //     "Plinths, chambers and minor civils for utilities, commercial and local authority projects.",
  //   items: [
  //     "Plinths & bases",
  //     "Chambers & service boxes",
  //     "To drawings & specification",
  //   ],
  // },
];

const projects = [
  {
    title: "Residential New Build – Foundations & Services",
    location: "Rochestown, Cork",
    scope:
      "Excavated and poured strip foundations, installed foul and storm drainage, ducting and concrete paths.",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
  },
  {
    title: "Commercial Yard Upgrade",
    location: "Little Island, Cork",
    scope:
      "Reduced levels, hardcore laid and compacted, concrete apron and drainage channels to spec.",
    image:
      "https://images.unsplash.com/photo-1529429617124-aee711a70432?auto=format&fit=crop&w=1600&q=80",
  },
  {
    title: "Public Footpath & Kerbing",
    location: "Carrigaline, Co. Cork",
    scope:
      "Kerbing, concrete footpath and reinstatement in partnership with local stakeholders.",
    image:
      "https://images.unsplash.com/photo-1529429617124-95b109e86e62?auto=format&fit=crop&w=1600&q=80",
  },
];

const process = [
  {
    step: "01",
    title: "Send your plans",
    detail:
      "Email drawings, measurements or even photos from site – the more info we have, the faster we can price.",
  },
  {
    step: "02",
    title: "Site visit (Cork & nearby)",
    detail:
      "We come out, confirm access, depths and services so there are no surprises once we mobilise.",
  },
  {
    step: "03",
    title: "Clear quotation",
    detail:
      "You get a straightforward price, broken down by sections if you need it for your own client.",
  },
  {
    step: "04",
    title: "Mobilise & deliver",
    detail:
      "Plant, materials and crew arrive on the agreed day. We work safely, tidy and to spec.",
  },
  {
    step: "05",
    title: "Sign-off",
    detail:
      "Final checks, tidy-up and handover so the next trade can get straight in.",
  },
];

// const testimonials = [
//   {
//     quote:
//       "GroundTech handled all the drainage and concrete works for our extension in Cork. Turned up when they said and left it spotless.",
//     name: "Michael O.",
//     role: "Homeowner, Douglas",
//   },
//   {
//     quote:
//       "Good civil outfit – priced off drawings, coordinated with us, and the levels were spot on.",
//     name: "K. Murphy",
//     role: "Local builder, Midleton",
//   },
//   {
//     quote:
//       "We needed kerbing and footpaths reinstated quickly. GroundTech got it done and dealt with the safety side too.",
//     name: "Site Supervisor",
//     role: "Commercial client, Cork",
//   },
// ];

const contactChannels = [
  {
    label: "Call Cork office",
    value: "087 053 0364",
    href: "tel:+353870530364",
  },
  {
    label: "Call site mobile",
    value: "085 252 9370",
    href: "tel:+353852529370",
  },
  {
    label: "Email drawings",
    value: "info@groundtech.ie",
    href: "mailto:info@groundtech.ie",
  },
  { label: "Yard & office", value: "Cork / Midleton area", href: null },
];

const trustSignals = [
  "Main drainage and utility installation",
  "Water mains and connections",
  "Roadworks and reinstatement",
  "Full civil works from foundation to finished floor level",
  "In-house setting out, water welding, and traffic management services",
];

const assuranceHighlights = [
  "Local team, fast mobilisation",
  "Tidy finish & reinstatement",
  "Ideal for domestic, commercial & council work",
];

const initialQuoteForm = {
  name: "",
  email: "",
  phone: "",
  purpose: "",
  message: "",
};

const validateQuoteForm = (values) => {
  const errors = {};

  if (!values.name.trim()) {
    errors.name = "Name is required";
  }

  if (!values.email.trim()) {
    errors.email = "Email is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) {
    errors.email = "Enter a valid email";
  }

  if (!values.phone.trim()) {
    errors.phone = "Phone number is required";
  } else if (!/^[+0-9\s().-]{6,}$/.test(values.phone.trim())) {
    errors.phone = "Enter a valid phone number";
  }

  if (!values.purpose.trim()) {
    errors.purpose = "Purpose of contact is required";
  }

  if (!values.message.trim()) {
    errors.message = "Message is required";
  }

  return errors;
};

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [quoteModalOpen, setQuoteModalOpen] = useState(false);
  const [quoteForm, setQuoteForm] = useState(initialQuoteForm);
  const [quoteErrors, setQuoteErrors] = useState({});
  const [quoteStatus, setQuoteStatus] = useState({
    state: "idle",
    message: "",
  });
  const [quoteFormSubmitted, setQuoteFormSubmitted] = useState(false);
  const quoteFormRef = useRef(null);
  const quoteFormTargetRef = useRef(null);
  const closeMenu = () => setMobileMenuOpen(false);

  const openQuoteModal = () => {
    setQuoteModalOpen(true);
    setQuoteErrors({});
    setQuoteStatus({ state: "idle", message: "" });
    setQuoteFormSubmitted(false);
  };

  const closeQuoteModal = () => {
    setQuoteModalOpen(false);
    setQuoteFormSubmitted(false);
  };

  const handleQuoteFieldChange = (event) => {
    const { name, value } = event.target;
    setQuoteForm((prev) => ({ ...prev, [name]: value }));
    setQuoteErrors((prev) => {
      if (!prev[name]) return prev;
      const { [name]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleQuoteSubmit = (event) => {
    event.preventDefault();
    const errors = validateQuoteForm(quoteForm);

    if (Object.keys(errors).length > 0) {
      setQuoteErrors(errors);
      return;
    }

    setQuoteStatus({ state: "loading", message: "Sending your request..." });

    if (quoteFormRef.current) {
      setQuoteFormSubmitted(true);
      quoteFormRef.current.submit();
    }
  };

  const handleQuoteSubmitComplete = () => {
    if (!quoteFormSubmitted) {
      return;
    }

    let iframeText = "";

    try {
      const iframeDocument =
        quoteFormTargetRef.current?.contentDocument ||
        quoteFormTargetRef.current?.contentWindow?.document;

      iframeText =
        iframeDocument?.body?.textContent?.toLowerCase().trim() || "";
    } catch (_error) {
      iframeText = "";
    }

    if (iframeText.includes("error") || iframeText.includes("invalid")) {
      setQuoteStatus({
        state: "error",
        message:
          "We couldn’t send that right now. Please try again or email info@groundtech.ie directly.",
      });
    } else {
      setQuoteStatus({
        state: "success",
        message: "Thanks – we’ve received your request and will respond soon.",
      });
      setQuoteForm(initialQuoteForm);
      setQuoteErrors({});
    }

    setQuoteFormSubmitted(false);
  };

  return (
    <div className="site">
      {quoteModalOpen && (
        <div className="quote-modal">
          <div
            className="quote-modal__overlay"
            onClick={closeQuoteModal}
            aria-hidden="true"
          />
          <section
            className="quote-modal__panel"
            role="dialog"
            aria-modal="true"
            aria-labelledby="quote-modal-title"
          >
            <button
              type="button"
              className="quote-modal__close"
              onClick={closeQuoteModal}
              aria-label="Close request a quote form"
            >
              &times;
            </button>
            <div className="quote-modal__header">
              <p className="eyebrow">Request a quote</p>
              <h2 id="quote-modal-title">Tell us about your project</h2>
              <p>
                Pop your details below and we&apos;ll get the right person to
                call or email you back.
              </p>
            </div>

            <form
              ref={quoteFormRef}
              className="quote-form"
              onSubmit={handleQuoteSubmit}
              noValidate
              action="https://formsubmit.co/info@groundtech.ie"
              method="POST"
              target="quote-form-target"
            >
              <input
                type="hidden"
                name="_subject"
                value={`New quote request from ${
                  quoteForm.name || "GroundTech site"
                }`}
              />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_replyto" value={quoteForm.email} />
              <input
                type="hidden"
                name="form"
                value="GroundTech quote request"
              />
              <div className="form-field">
                <label htmlFor="quote-name">Name</label>
                <input
                  id="quote-name"
                  name="name"
                  type="text"
                  autoComplete="name"
                  value={quoteForm.name}
                  onChange={handleQuoteFieldChange}
                />
                {quoteErrors.name && (
                  <p className="field-error">{quoteErrors.name}</p>
                )}
              </div>

              <div className="form-field">
                <label htmlFor="quote-email">Email</label>
                <input
                  id="quote-email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={quoteForm.email}
                  onChange={handleQuoteFieldChange}
                />
                {quoteErrors.email && (
                  <p className="field-error">{quoteErrors.email}</p>
                )}
              </div>

              <div className="form-field">
                <label htmlFor="quote-phone">Phone</label>
                <input
                  id="quote-phone"
                  name="phone"
                  type="tel"
                  autoComplete="tel"
                  value={quoteForm.phone}
                  onChange={handleQuoteFieldChange}
                />
                {quoteErrors.phone && (
                  <p className="field-error">{quoteErrors.phone}</p>
                )}
              </div>

              <div className="form-field">
                <label htmlFor="quote-purpose">Purpose of contact</label>
                <input
                  id="quote-purpose"
                  name="purpose"
                  type="text"
                  value={quoteForm.purpose}
                  onChange={handleQuoteFieldChange}
                />
                {quoteErrors.purpose && (
                  <p className="field-error">{quoteErrors.purpose}</p>
                )}
              </div>

              <div className="form-field">
                <label htmlFor="quote-message">Message</label>
                <textarea
                  id="quote-message"
                  name="message"
                  rows={4}
                  value={quoteForm.message}
                  onChange={handleQuoteFieldChange}
                />
                {quoteErrors.message && (
                  <p className="field-error">{quoteErrors.message}</p>
                )}
              </div>

              {quoteStatus.message && (
                <p
                  className={`quote-form__status quote-form__status--${quoteStatus.state}`}
                  role={quoteStatus.state === "error" ? "alert" : undefined}
                >
                  {quoteStatus.message}
                </p>
              )}

              <div className="quote-form__actions">
                <button
                  className="btn-primary"
                  type="submit"
                  disabled={quoteStatus.state === "loading"}
                >
                  {quoteStatus.state === "loading"
                    ? "Sending..."
                    : "Send request"}
                </button>
                <button
                  className="btn-secondary"
                  type="button"
                  onClick={closeQuoteModal}
                >
                  Cancel
                </button>
              </div>
            </form>
            <iframe
              name="quote-form-target"
              title="GroundTech quote form handler"
              className="quote-form__iframe"
              ref={quoteFormTargetRef}
              onLoad={handleQuoteSubmitComplete}
            />
          </section>
        </div>
      )}
      <header
        className="site-header"
        style={{
          backgroundColor: "#151515",
          color: "#fff",
        }}
      >
        <div className="site-header__inner">
          <a className="brand" href="#home">
            <img
              src="/groundtech-logo.jpg"
              alt="GroundTech Civil & Construction Ltd"
              loading="lazy"
            />
          </a>
          <button
            type="button"
            className={`mobile-toggle${mobileMenuOpen ? " is-open" : ""}`}
            aria-expanded={mobileMenuOpen}
            aria-label={mobileMenuOpen ? "Close navigation" : "Open navigation"}
            onClick={() => setMobileMenuOpen((prev) => !prev)}
          >
            <span />
            <span />
            <span />
          </button>
          <nav
            className={`site-header__menu${mobileMenuOpen ? " is-open" : ""}`}
          >
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={closeMenu}
                style={{ color: "#fff" }}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main>
        {/* HERO */}
        <section
          className="hero"
          id="home"
          style={{
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* background image now SHADOWED (darkened) not blurred */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: "url(/hero-excavator.jpg)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "brightness(0.75)", // main shadow/darken
              transform: "scale(1.05)",
              zIndex: 0,
            }}
            aria-hidden="true"
          />
          {/* extra gradient to make text pop */}
          <div
            className="hero-overlay"
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.75) 100%)",
              zIndex: 1,
            }}
          />
          <div
            className="hero-container"
            style={{ position: "relative", zIndex: 2 }}
          >
            <div className="hero-body">
              <h1 className="hero-title">
                GroundTech Civil & Construction Ltd
              </h1>
              <p className="hero-subtitle">
                Groundtech Civil &amp; Construction Ltd. is a forward-thinking
                construction firm located in Cork City, dedicated to delivering
                exceptional services across all facets of construction,
                including Groundworks, Civil Engineering, and Concrete Works.
                Our expertise encompasses a variety of sectors, with a
                particular emphasis on Building, Civil, and pharmaceutical
                industries, addressing projects that involve:
              </p>

              <ul className="hero-trust">
                {trustSignals.map((signal) => (
                  <li key={signal}>{signal}</li>
                ))}
              </ul>

              <div className="hero-actions">
                <button
                  className="btn-primary"
                  type="button"
                  onClick={openQuoteModal}
                >
                  Request a quote
                </button>
                <a className="btn-secondary" href="#services">
                  View our services
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* ABOUT / WHY */}
        <section className="section" id="about">
          <div className="section-heading">
            <p className="eyebrow">Why Cork builders use us</p>
            <h2>A local groundwork crew that turns up and finishes right.</h2>
          </div>
          <div className="about-grid">
            {whyChooseUs.map((item) => (
              <article key={item.title} className="about-card">
                <h3>{item.title}</h3>
                <p>{item.body}</p>
                <ul>
                  {item.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        {/* SERVICES */}
        <section className="section alt" id="services">
          <div className="section-heading narrow">
            <p className="eyebrow">Services</p>
            <h2>Groundworks & civil services for Cork projects.</h2>
            <p>
              If you&apos;re building in Cork – new build, extension, commercial
              unit or council job – we can handle the groundwork stage for you.
            </p>
          </div>
          <div className="service-grid">
            {services.map((service) => (
              <article key={service.title} className="service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        {/* PROJECTS */}
        <section className="section" id="projects">
          <div className="section-heading narrow">
            <p className="eyebrow">Recent work</p>
            <h2>Groundworks completed across Cork.</h2>
            <p>
              A small sample of residential, commercial and public jobs we’ve
              delivered locally.
            </p>
          </div>
          <div className="project-grid">
            {projects.map((project) => (
              <article key={project.title} className="project-card">
                <figure>
                  <img src={project.image} alt={project.title} />
                  <figcaption>{project.location}</figcaption>
                </figure>
                <div className="project-body">
                  <h3>{project.title}</h3>
                  <p>{project.scope}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        {/* PROCESS */}
        <section className="section alt" id="process">
          <div className="section-heading">
            <p className="eyebrow">Our process</p>
            <h2>Simple, tidy and transparent.</h2>
            <p>
              We don’t overcomplicate it – get us your info, we price it, we
              turn up and get it done to spec.
            </p>
          </div>
          <div className="process-flow">
            {process.map((phase) => (
              <div key={phase.step} className="process-card">
                <span className="process-step">{phase.step}</span>
                <h3>{phase.title}</h3>
                <p>{phase.detail}</p>
              </div>
            ))}
          </div>
        </section>

        {/* TESTIMONIALS */}
        {/* <section className="section" id="testimonials">
          <div className="section-heading narrow">
            <p className="eyebrow">What clients say</p>
            <h2>Reliable groundworks for Cork homeowners & builders.</h2>
          </div>
          <div className="testimonial-grid">
            {testimonials.map((testimonial) => (
              <blockquote key={testimonial.name} className="testimonial-card">
                <p>“{testimonial.quote}”</p>
                <footer>
                  <strong>{testimonial.name}</strong>
                  <span>{testimonial.role}</span>
                </footer>
              </blockquote>
            ))}
          </div>
        </section> */}

        {/* CONTACT */}
        <section className="section alt contact" id="contact">
          <div className="contact-card">
            <div className="contact-copy">
              <p className="eyebrow">Get a price</p>
              <h2>
                Send drawings, measurements or photos and we&apos;ll quote your
                Cork project.
              </h2>
              <p>
                Ideal for builders, homeowners and commercial clients around
                Cork who need excavation, drainage, concrete or kerbing done
                properly.
              </p>
              <p>
                You can also ask if we cover your exact area – we usually do if
                it&apos;s within reach of Cork.
              </p>
            </div>
            <div className="contact-actions">
              {contactChannels.map((channel) =>
                channel.href ? (
                  <a
                    key={channel.label}
                    className="contact-link"
                    href={channel.href}
                  >
                    <span>{channel.label}</span>
                    <strong>{channel.value}</strong>
                  </a>
                ) : (
                  <div key={channel.label} className="contact-link inactive">
                    <span>{channel.label}</span>
                    <strong>{channel.value}</strong>
                  </div>
                ),
              )}
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="brand brand--footer">
              <img
                src="/groundtech-logo.jpg"
                alt="GroundTech Civil & Construction Ltd"
                loading="lazy"
              />
            </div>
            <p>
              Groundworks, drainage, concrete and kerbing for projects across
              Cork – delivered safely and to specification.
            </p>
          </div>
          <div className="footer-grid">
            <div>
              <h4>Navigation</h4>
              <div className="footer-links">
                {navLinks.map((link) => (
                  <a key={link.href} href={link.href}>
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h4>Contact</h4>
              <div className="footer-links">
                {contactChannels.map((channel) =>
                  channel.href ? (
                    <a key={channel.label} href={channel.href}>
                      {channel.value}
                    </a>
                  ) : (
                    <span key={channel.label}>{channel.value}</span>
                  ),
                )}
              </div>
            </div>
            <div>
              <h4>Assurances</h4>
              <ul className="footer-credentials">
                {assuranceHighlights.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="footer-meta">
            <span>
              &copy; {new Date().getFullYear()} GroundTech Civil & Construction
              Ltd, Cork. All rights reserved.
            </span>
            <span>
              Cork • Midleton • Carrigaline • Little Island • Glanmire
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
